/** @jsx jsx */
import React from "react"
import { jsx, ThemeUIStyleObject } from "theme-ui"
import { getThemeVariantStyles } from "@styles/utils/getThemeVariant"
import { PrimitiveProps } from "@styles/types"

export interface IconProps extends PrimitiveProps, React.SVGProps<SVGElement> {
  svg: React.FC<React.SVGProps<SVGElement> & { title?: string }>
  title?: string
}

export const iconStyles: ThemeUIStyleObject = {}

const Icon: React.FC<IconProps> = ({ sx, variant, svg: SvgIcon, ...props }) => (
  <SvgIcon
    sx={{
      ...iconStyles,
      ...sx,
      ...(variant && { ...getThemeVariantStyles("icons", variant) }),
    }}
    {...(props.title && { "aria-label": props.title })}
    {...props}
  />
)

Icon.defaultProps = {
  "aria-hidden": true,
  focusable: false,
}

export { Icon }
